import amplitude from 'utils/amplitude';
import { EnumEvents } from 'constants/enums';
import { IShop } from 'Modules/Shops/types';
import { ICheckoutOrder } from './types';
import checkoutSuccessAnalytic from 'utils/analitic/checkoutSuccessAnalytic';
import { PaymentTypes } from '../../Modules/Checkout/types';
import { checkoutEnterCard } from 'utils/tagManager/handlers/checkout';

export default function checkoutPaymentSuccessAnalytic(order: ICheckoutOrder, shop: IShop, asap: boolean): void {
  checkoutEnterCard();
  checkoutSuccessAnalytic(order, shop, asap, PaymentTypes.online);

  amplitude.logEvent(EnumEvents.CHECKOUT_ENTER_CARD, {
    'order id': order.id,
  });
}
